export enum SpinnerWidth {
    Thin = 2,
    Medium = 3,
    Thick = 4,
}
